import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-490b61e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coaching-session-loading-view" }
const _hoisted_2 = { class: "coaching-session-loading-view__header" }
const _hoisted_3 = { class: "coaching-session-loading-view__title" }
const _hoisted_4 = { class: "coaching-session-loading-view__detail" }
const _hoisted_5 = { class: "coaching-session-loading-view__next-session" }

import BsPlaceholder from '@/components/BsPlaceholder/BsPlaceholder.vue'
import locales from '../CoachingSessionView/CoachingSessionView.locales.en.json'

export default /*#__PURE__*/_defineComponent({
  __name: 'CoachingSessionLoadingView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(locales).title_coaching_session), 1),
      _createElementVNode("div", null, [
        _createVNode(BsPlaceholder, { pattern: "####" })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(BsPlaceholder, { pattern: "### #######" })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(BsPlaceholder, { pattern: "####" })
    ])
  ]))
}
}

})